import React, { useState } from 'react';
import axios from 'axios';
import { Col, Container, Row, Form, FormGroup, Input, Button } from 'reactstrap';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { toast } from 'react-toastify';
const Address = () => {
    const [formData, setFormData] = useState({
        name: "",
        email_id: "",
        phone_number:"",
        subject: "",
        message: ""
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/enquiry`, formData);
            toast.success("Message sent successfully!");
            setFormData({ name: "", email_id: "",phone_number:"", subject: "", message: "" });
        } catch (error) {
            toast.error("Failed to send message. Please try again.");
        }
    };

    return (
        <React.Fragment>
            <section className="section bg-light py-5" id="features">
                <Container>
                    <Row className="align-items-center gy-4">
                        <div className="text-muted">
                            <div className="text-center">
                                <h2 className="fw-bold mt-5" style={{ fontSize: "2rem", color: "#F15A29" }}>Contact Us</h2>
                            </div>
                        </div>
                    </Row>
                </Container>
            </section>

            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8} sm={10}>
                            <Row className="justify-content-center text-center">
                                <Col lg={8}>
                                    <h2 className="fw-bold">Let's Connect to know more</h2>
                                    <p className="text-muted">
                                        Explore how OffisoIndia can simplify your office needs.
                                        Our team is here to provide tailored solutions and answer all your queries.
                                    </p>
                                </Col>
                            </Row>
                            <Row className="mt-4">
                                <Col lg={4} className="text-center text-lg-start">
                                    <p className="fw-bold mb-1">📞 +91 702 899 0059</p>
                                    <p>
                                        <a href="mailto:operations@offisoindia.com" className="text-primary">
                                            contact@offisoindia.com
                                        </a>
                                    </p>
                                    <p>
                                        <h6 className='fw-bold'style={{fontSize: "14px"}}>Corporate Office</h6>
                                        <span className='fs-1rm' >-Offisoindia Distribution Pvt. Ltd.</span>
                                        <i className="fas fa-map-marker-alt"> </i>
                                        &nbsp;Bluepearl 204 Paradise, A-302, behind Royal Enfield Showroom, Riviresa Society, Baner, Pune, Maharashtra 411045
                                    </p>
                                    <p>
                                        <h6 className='fw-bold'style={{fontSize: "14px"}}>Warehouse Office</h6>
                                        <span className='fs-1rm' >-Offisoindia Distribution Pvt. Ltd.</span>
                                        <i className="fas fa-map-marker-alt"> </i>
                                        &nbsp;Vishal Nagar, Pimple Nilakh, Pune, Maharashtra 411027
                                    </p>
                                    
                                </Col>
                                <Col lg={8}>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Input type="text" name="name" placeholder="Your name*" required value={formData.name} onChange={handleChange} />
                                                </FormGroup>
                                            </Col>
                                            <Col md={6}>
                                                <FormGroup>
                                                    <Input type="email" name="email_id" placeholder="Your email*" required value={formData.email_id} onChange={handleChange} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <FormGroup>
                                            <Input type="tel" name="phone_number" placeholder="Your phone number*" required value={formData.phone_number} onChange={handleChange} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Input type="text" name="subject" placeholder="Your Subject*" required value={formData.subject} onChange={handleChange} />
                                        </FormGroup>
                                        <FormGroup>
                                            <Input type="textarea" name="message" placeholder="Your message..." rows="4" required value={formData.message} onChange={handleChange} />
                                        </FormGroup>
                                        <Button type="submit" color="primary" className="w-100">Send Message</Button>
                                    </Form>
                                </Col>
                            </Row>
                            <Row className="mt-5">
                                <Col>
                                    <iframe
                                        title="Google Map"
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.726640132722!2d73.7927588!3d18.5590102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf6658f6c259%3A0xed75dae8d75a2c87!2sBluepearl%20204%20Paradise!5e0!3m2!1sen!2sin!4v1708784523010"
                                        width="100%"
                                        height="400"
                                        style={{ border: 0 }}
                                        allowfullscreen=""
                                        loading="lazy"
                                        referrerpolicy="no-referrer-when-downgrade">
                                    </iframe>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Address;
